import React from 'react'
import { Container } from './style'

const ProductImg = props => <Container {...props} />

export default ProductImg
